/* Datum & Ink — the live centre piece of the gallery hero.

   Cycles the featured product's framing options while the visitor is on it.
   Options are whatever products the bound collection holds, so adding one in
   Shopify adds it to the rotation with no code change.

   Two deliberate choices:

   - Hovering advances one option IMMEDIATELY, then the interval takes over.
     Waiting a full beat before anything moves reads as broken, and it also
     means the behaviour can be verified without depending on a timer.
   - Elements are re-queried on every tick rather than captured once, so a
     section re-render (theme editor, app injection) cannot leave this driving
     detached nodes.

   The active index lives on the element as data-di-active so state is
   inspectable and survives anything that re-runs this script. */
(function () {
  var ROTATE_MS = 1100;

  function parts(feature) {
    return {
      imgs: feature.querySelectorAll('.di-hero__feature-img'),
      labels: feature.querySelectorAll('.di-hero__feature-label')
    };
  }

  function show(feature, n) {
    var p = parts(feature);
    var len = p.imgs.length;
    if (!len) return;
    var idx = ((n % len) + len) % len;
    feature.dataset.diActive = idx;
    for (var i = 0; i < len; i++) {
      p.imgs[i].classList.toggle('is-on', i === idx);
      if (p.labels[i]) p.labels[i].classList.toggle('is-on', i === idx);
    }
  }

  function activeIndex(feature) {
    return parseInt(feature.dataset.diActive, 10) || 0;
  }

  function begin(feature) {
    if (feature.__diTimer) return;
    show(feature, activeIndex(feature) + 1);
    feature.__diTimer = setInterval(function () {
      show(feature, activeIndex(feature) + 1);
    }, ROTATE_MS);
  }

  function end(feature) {
    clearInterval(feature.__diTimer);
    feature.__diTimer = 0;
    show(feature, 0);                 // settle back on the lead option
  }

  // Delegated, so this keeps working if the section markup is replaced.
  function bind() {
    if (document.__diFeatureBound) return;
    document.__diFeatureBound = true;

    var touch = window.matchMedia('(hover: none)').matches;

    document.addEventListener('pointerover', function (e) {
      if (touch || !e.target.closest) return;
      var f = e.target.closest('.di-hero__feature');
      if (f && !f.contains(e.relatedTarget)) begin(f);
    });

    document.addEventListener('pointerout', function (e) {
      if (touch || !e.target.closest) return;
      var f = e.target.closest('.di-hero__feature');
      if (f && !f.contains(e.relatedTarget)) end(f);
    });

    document.addEventListener('focusin', function (e) {
      if (!e.target.closest) return;
      var f = e.target.closest('.di-hero__feature');
      if (f) begin(f);
    });

    document.addEventListener('focusout', function (e) {
      if (!e.target.closest) return;
      var f = e.target.closest('.di-hero__feature');
      if (f && !f.contains(e.relatedTarget)) end(f);
    });

    // Touch has no hover: a tap would otherwise follow the link before showing
    // anything, so step one option per tap and only follow on the last.
    document.addEventListener('click', function (e) {
      if (!touch || !e.target.closest) return;
      var f = e.target.closest('.di-hero__feature');
      if (!f) return;
      var len = parts(f).imgs.length;
      if (activeIndex(f) < len - 1) {
        e.preventDefault();
        show(f, activeIndex(f) + 1);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
